import React from 'react'
import styled from 'styled-components'
import Footer from '../Footer'
const Page: React.FC = ({children}) => (
    <StyledPage>
        <StyledMain>{children}</StyledMain>
        <Footer/>
    </StyledPage>
);

const StyledPage = styled.div`
 `;

const StyledMain = styled.div`
padding-bottom: 40px;
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${(props) => props.theme.topBarSize * 2}px);
  
   //background-size: 400px 400px;
   //background-position-x: center;
   //background-position-y: 50px;
    
`;

export default Page
